<template>
  <div class="talent-page">
    <section class="talent-hero subpage-image-hero">
      <img src="@/assets/image/talent_banner.png" alt="招全国代理">
      <div class="container subpage-hero-inner">
        <div class="subpage-hero-copy">
          <span style="font-size: 2rem; font-weight: 600;">招全国代理</span>
          <p>智创共赢，掘金百亿物联蓝海，携手定义安全未来</p>
        </div>
      </div>
    </section>

    <section id="process" class="talent-process-section">
      <div class="container">
        <div class="talent-title">
          <h2>加入代理流程</h2>
          <span>QIANXUN PLATFORM</span>
        </div>
        <div class="talent-process-grid">
          <article v-for="item in processList" :key="item.title" class="talent-process-card">
            <img :src="item.icon" :alt="item.title">
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </article>
        </div>
      </div>
    </section>

    <section id="join" class="join-section">
      <div class="container">
        <div class="talent-title">
          <h2>加入我们</h2>
          <span>JOIN US</span>
        </div>
        <form class="talent-join-form" @submit.prevent="submitTalentForm">
          <label>
            <span>公司名称<em>*</em></span>
            <input v-model.trim="form.company_name" type="text" placeholder="请输入公司名称">
          </label>
          <label>
            <span>您的称呼<em>*</em></span>
            <input v-model.trim="form.title" type="text" placeholder="请填写您的称呼">
          </label>
          <label>
            <span>联系电话<em>*</em></span>
            <input v-model.trim="form.phone" type="tel" placeholder="请填写联系电话">
          </label>
          <label>
            <span>联系邮箱<em>*</em></span>
            <input v-model.trim="form.email" type="email" placeholder="请填写联系邮箱">
          </label>
          <label class="wide">
            <span>意向城市<em>*</em></span>
            <input v-model.trim="form.address" type="text" placeholder="请填写意向城市">
          </label>
          <label class="message">
            <b>备注</b>
            <textarea v-model.trim="form.remark" rows="8" placeholder="请输入备注"></textarea>
          </label>
          <button type="submit" :disabled="isSubmitting">
            {{ isSubmitting ? '提交中...' : '提交资料' }}
          </button>
          <p v-if="formMessage" class="talent-form-tip" :class="{ error: formMessageType === 'error' }">
            {{ formMessage }}
          </p>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'TalentView',
  data() {
    return {
      apiUrl: 'https://www.gps555.net/submit',
      isSubmitting: false,
      formMessage: '',
      formMessageType: '',
      form: {
        company_name: '',
        email: '',
        phone: '',
        title: '',
        address: '',
        remark: ''
      },
      processList: [
        { title: '提交合作咨询', desc: '向千讯云创平台提交合作意向\n描述项目背景和预算', icon: require('@/assets/image/talent1.png') },
        { title: '初步洽谈', desc: '千讯员工会在5个工作日内联系您\n电话沟通情况', icon: require('@/assets/image/talent2.png') },
        { title: '深度洽谈', desc: '需求沟通明确后，千讯工作人员为您\n定制合作方案', icon: require('@/assets/image/talent3.png') },
        { title: '意向签约', desc: '签订区域代理协议，明确权益范围与\n业绩目标', icon: require('@/assets/image/talent4.png') }
      ]
    }
  },
  methods: {
    validateForm() {
      const requiredFields = [
        { key: 'company_name', label: '公司名称' },
        { key: 'title', label: '您的称呼' },
        { key: 'phone', label: '联系电话' },
        { key: 'email', label: '联系邮箱' },
        { key: 'address', label: '意向城市' }
      ]
      const emptyField = requiredFields.find(item => !this.form[item.key])

      if (emptyField) {
        return `请填写${emptyField.label}`
      }

      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        return '请填写正确的联系电话'
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email)) {
        return '请填写正确的联系邮箱'
      }

      return ''
    },
    resetForm() {
      this.form = {
        company_name: '',
        email: '',
        phone: '',
        title: '',
        address: '',
        remark: ''
      }
    },
    async submitTalentForm() {
      const validationMessage = this.validateForm()

      if (validationMessage) {
        this.formMessage = validationMessage
        this.formMessageType = 'error'
        return
      }

      this.isSubmitting = true
      this.formMessage = ''
      this.formMessageType = ''

      try {
        const response = await fetch(this.apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(this.form)
        })
        const result = await response.json()

        if (!response.ok || result.code !== 0) {
          throw new Error(result.msg || '提交失败，请稍后再试')
        }

        this.formMessage = '提交成功，我们会尽快与您联系'
        this.formMessageType = 'success'
        this.resetForm()
      } catch (error) {
        this.formMessage = error.message || '提交失败，请稍后再试'
        this.formMessageType = 'error'
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>
